import { useEffect } from "react"
import { WEEKPLAN } from "../../config"
import Calender from "./Calender"

const CarouselCalender = () => {
	function printDays() {
		const coll: any = []

		const today = new Date()
		const dayOfWeek = today.getDay()

		for (let i = 3; i >= 1; i--) {
			coll.push(<Calender key={"weekday-" + i} className={"weekday-" + i} dayContent={WEEKPLAN.filter(weekday => weekday.getDay === (dayOfWeek + 7 - i) % 7)[0]} />)
		}

		coll.push(<Calender className={"weekday"} dayContent={WEEKPLAN.filter(weekday => weekday.getDay === dayOfWeek)[0]} />)

		for (let i = 1; i <= 3; i++) {
			coll.push(<Calender className={"weekday" + i} key={"weekday" + i} dayContent={WEEKPLAN.filter(weekday => weekday.getDay === (dayOfWeek + i) % 7)[0]} />)
		}

		return coll
	}

	useEffect(() => {
		printDays()
	}, [])

	return <div className="relative">{printDays()}</div>
}
export default CarouselCalender
